import { HelpCircle } from 'lucide-react';
import Link from 'next/link';
import { Button } from '../ui/button.jsx';
import { cn } from '../../lib/utils.js';
export function HelpCenterNavButton(_a) {
    var _b = _a.href, href = _b === void 0 ? 'https://help.govinity.com' : _b, _c = _a.showText, showText = _c === void 0 ? false : _c, className = _a.className, _d = _a.variant, variant = _d === void 0 ? 'ghost' : _d;
    return (<Button asChild aria-label="Go to Help Center (opens in a new tab)" variant={variant} size={showText ? 'sm' : 'icon'} className={className} title="Go to Help Center">
      <Link href={href} target="_blank" rel="noopener noreferrer" className={cn(showText && 'flex items-center gap-2')}>
        <HelpCircle className="h-[1.2rem] w-[1.2rem]"/>
        <span className={cn(!showText && 'sr-only')}>Help Center</span>
      </Link>
    </Button>);
}
